export default __webpack_public_path__ + "static/media/question.5a18d10e.svg";